<template>
  <div>
    <Head title="客戶級別管理" />
    <ScrollTop />

    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <user-level-template>
      <div class="border border-fh-gray-light px-3">
        <div class="border border-fh-gray-light p-3 my-3">
          <div class="user_level_settings_title">升級條件</div>
          <div class="user_level_settings_description">
            當滿足以下任意一個條件，「一般會員」將顯示於「符合升級資格」清單中。
          </div>
          <div class="flex flex-row flex-nowrap gap-2 my-2">
            <div>
              <Checkbox
                id="regular_check_amount"
                v-model="settings.regular.cv.checked"
                :binary="true"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div><label for="regular_check_amount">累積消費金額</label></div>
              <div>
                計算週期：<InputNumber
                  showButtons
                  v-model="settings.regular.cv.period"
                  :min="0"
                />
                （0: 自註冊日起）
              </div>
              <div>
                <Dropdown
                  :options="amount_options"
                  optionLabel="name"
                  optionValue="code"
                  v-model="settings.regular.cv.referred"
                />：<InputNumber
                  showButtons
                  v-model="settings.regular.cv.amount"
                  :min="0"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-row flex-nowrap gap-2 my-2">
            <div>
              <Checkbox
                id="regular_check_referred"
                v-model="settings.regular.referred.checked"
                :binary="true"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div><label for="regular_check_referred">推廣人數</label></div>
              <div>
                計算週期：<InputNumber
                  showButtons
                  v-model="settings.regular.referred.period"
                  :min="0"
                />
                （0: 自註冊日起）
              </div>
              <div>
                推廣人數：<InputNumber
                  showButtons
                  v-model="settings.regular.referred.quantity"
                  :min="0"
                />
                人
              </div>
            </div>
          </div>
        </div>

        <div class="border border-fh-gray-light p-3 my-3">
          <div class="user_level_settings_title">維持會員條件</div>
          <div class="user_level_settings_description">
            當滿足以下任意一個條件，「推廣會員」將可以維持資格，如不符合則自動降級為「一般會員」。
          </div>
          <div class="flex flex-row flex-nowrap gap-2 my-2">
            <div>
              <Checkbox
                id="upgraded_check_amount"
                v-model="settings.upgraded.cv.checked"
                :binary="true"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div><label for="upgraded_check_amount">累積消費金額</label></div>
              <div>
                計算週期：<InputNumber
                  showButtons
                  v-model="settings.upgraded.cv.period"
                  :min="1"
                />
                <!-- （0: 自升級日起） -->
              </div>
              <div>
                <Dropdown
                  :options="amount_options"
                  optionLabel="name"
                  optionValue="code"
                  v-model="settings.upgraded.cv.referred"
                />：<InputNumber
                  showButtons
                  v-model="settings.upgraded.cv.amount"
                  :min="0"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-row flex-nowrap gap-2 my-2">
            <div>
              <Checkbox
                id="upgraded_check_referred"
                v-model="settings.upgraded.referred.checked"
                :binary="true"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div><label for="upgraded_check_referred">推廣人數</label></div>
              <div>
                計算週期：<InputNumber
                  showButtons
                  v-model="settings.upgraded.referred.period"
                  :min="1"
                />
                <!-- （0: 自升級日起） -->
              </div>
              <div>
                推廣人數：<InputNumber
                  showButtons
                  v-model="settings.upgraded.referred.quantity"
                  :min="0"
                />
                人
              </div>
            </div>
          </div>
        </div>

        <div class="border border-fh-gray-light p-3 my-3">
          <div class="user_level_settings_title">回升條件</div>
          <div class="user_level_settings_description">
            當滿足以下任意一個條件，被降級的「一般會員」將自動升級為「推廣會員」。
          </div>
          <div class="flex flex-row flex-nowrap gap-2 my-2">
            <div>
              <Checkbox
                id="degraded_check_amount"
                v-model="settings.degraded.cv.checked"
                :binary="true"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div><label for="degraded_check_amount">累積消費金額</label></div>
              <div>
                計算週期：<InputNumber
                  showButtons
                  v-model="settings.degraded.cv.period"
                  :min="0"
                />
                （0: 自降級日起）
              </div>
              <div>
                <Dropdown
                  :options="amount_options"
                  optionLabel="name"
                  optionValue="code"
                  v-model="settings.degraded.cv.referred"
                />：<InputNumber
                  showButtons
                  v-model="settings.degraded.cv.amount"
                  :min="0"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-row flex-nowrap gap-2 my-2">
            <div>
              <Checkbox
                id="degraded_check_referred"
                v-model="settings.degraded.referred.checked"
                :binary="true"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div><label for="degraded_check_referred">推廣人數</label></div>
              <div>
                計算週期：<InputNumber
                  showButtons
                  v-model="settings.degraded.referred.period"
                  :min="0"
                />
                （0: 自降級日起）
              </div>
              <div>
                推廣人數：<InputNumber
                  showButtons
                  v-model="settings.degraded.referred.quantity"
                  :min="0"
                />
                人
              </div>
            </div>
          </div>
        </div>

        <div class="text-right my-2">
          <Button label="儲存設定" @click="save_settings" />
        </div>
      </div>
    </user-level-template>
  </div>
</template>

<script>
import Layout from "../Layout";
import ScrollTop from "primevue/scrolltop";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import UserLevelTemplate from "./Shared/UserLevelTemplate";
import Checkbox from "primevue/checkbox";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";

export default {
  layout: Layout,
  components: {
    ScrollTop,
    Breadcrumb,
    UserLevelTemplate,
    Checkbox,
    InputNumber,
    Dropdown,
    Button,
  },
  props: {
    users: Object,
  },
  data() {
    return {
      breadcrumb_home: {
        label: "使用者管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label: "客戶級別管理",
          to: route("admin.users.level"),
        },
        {
          label: this.$page.props.breadcrumb_label,
          disabled: true,
        },
      ],
      amount_options: [
        { name: "C.V.", code: false },
        { name: "C.V.T.", code: true },
      ],
      settings: {
        regular: {
          cv: {
            checked: false,
            period: 1,
            referred: false,
            amount: 0,
          },
          referred: {
            checked: false,
            period: 1,
            quantity: 1,
          },
        },
        upgraded: {
          cv: {
            checked: false,
            period: 1,
            referred: false,
            amount: 0,
          },
          referred: {
            checked: false,
            period: 1,
            quantity: 1,
          },
        },
        degraded: {
          cv: {
            checked: false,
            period: 1,
            referred: false,
            amount: 0,
          },
          referred: {
            checked: false,
            period: 1,
            quantity: 1,
          },
        },
      },
    };
  },
  computed: {
    //
  },
  methods: {
    save_settings() {
      let result = {
        rules: {
          regular: {
            cv: {
              checked: false,
              amount: 0,
              period: 0,
              referred: false,
            },
            referral: {
              checked: false,
              period: 0,
              quantity: 0,
            },
          },
          degraded: {
            cv: {
              checked: false,
              amount: 0,
              period: 0,
              referred: false,
            },
            referral: {
              checked: false,
              period: 0,
              quantity: 0,
            },
          },
          upgraded: {
            cv: {
              checked: false,
              amount: 0,
              period: 0,
              referred: false,
            },
            referral: {
              checked: false,
              period: 0,
              quantity: 0,
            },
          },
        },
        settings: this.settings,
      };

      _.forEach(this.settings, function (type, key) {
        if (type.cv.checked) {
          result.rules[key].cv.checked = true;
          result.rules[key].cv.amount = type.cv.amount;
          result.rules[key].cv.period = type.cv.period;
          result.rules[key].cv.referred = type.cv.referred;
        }

        if (type.referred.checked) {
          result.rules[key].referral.checked = true;
          result.rules[key].referral.quantity = type.referred.quantity;
          result.rules[key].referral.period = type.referred.period;
        }
      });

      this.$inertia.post(route("admin.users.level.settings.save"), result);
    },
  },
  mounted() {
    this.settings = this.$page.props.settings;
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

.user_level_settings_title {
  @apply text-lg;
}

.user_level_settings_description {
  @apply text-sm;
}
</style>